import { __assign } from "tslib";
import { translations } from "../../../assets/translations";
import { ITranslations } from "../../models/translations";
import { IAction } from "../action";
import { actionTypes } from "../actions";
var initialState = translations;
export function translationsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.setTranslations:
            if (!action.payload) {
                return initialState;
            }
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}
